import { type SetFeaturesOptions, useSettings } from '@/hooks/useSettings';
import type { NoteDefaults } from '@/types/noteStyle';

/** The account's note style defaults; saving patches only the changed settings key. */
export const useNoteDefaults = () => {
  const { defaultNoteDetail, defaultNoteFormat, setFeatures, isReady } = useSettings();

  const saveNoteDefaults = ({ noteDetail, noteFormat }: Partial<NoteDefaults>, options?: SetFeaturesOptions) =>
    setFeatures(
      {
        ...(noteDetail && { default_note_detail: noteDetail }),
        ...(noteFormat !== undefined && { default_note_format: noteFormat }),
      },
      options
    );

  const noteDefaults: NoteDefaults = { noteDetail: defaultNoteDetail, noteFormat: defaultNoteFormat };

  return { noteDefaults, saveNoteDefaults, isReady };
};
